"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropDownPillMenuItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _price = require("@site/pattern-library-core/price");
var _pillItem = _interopRequireDefault(require("../common/pill-item"));
/** @module DropDownPillMenuItem */

/* VENDOR */

const Option = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Option",
  class: "pc-o1r81s0q"
});

/**
 * DropDownPillMenuItem
 * @param {Object} props React props
 * @param {Array<Object>} props.options List of DropDownPillMenuItems
 * @param {number} props.ariaLabel aria label for select element
 * @returns {React.ReactElement} DropDownPillMenuItem component
 * @public
 */
function DropDownPillMenuItem({
  id,
  savingsTag,
  termLength,
  termPrice,
  termTotalPrice,
  numberOfTerm,
  icon,
  a11yAttributes,
  isDomain
}) {
  const termContent = [{
    text: savingsTag,
    type: 'tag',
    dataCy: 'savings-tag',
    size: 'sm',
    design: 'warning'
  }, {
    text: termLength,
    type: 'title',
    dataCy: 'term-length',
    size: 0
  }];

  // For domains, termTotalPrice contains listpriceformatted (strikethrough)
  // For non-domains, termTotalPrice contains priceDescription (normal text)
  const isStrikethroughPrice = isDomain && termTotalPrice;
  const priceContent = [{
    text: termPrice,
    type: 'title',
    dataCy: 'term-price',
    size: 2
  }, {
    text: termTotalPrice,
    type: 'paragraph',
    dataCy: isStrikethroughPrice ? 'strikethru-price' : 'term-total-price',
    ...(isStrikethroughPrice && {
      'className': (0, _core.cx)('text-uppercase', _price.oldTagStyles),
      'aria-label': `Original price ${termTotalPrice}, crossed out`,
      'role': 'text'
    }),
    size: -1
  }];
  return /*#__PURE__*/_react.default.createElement(Option, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "dropdown-pill-menu-item",
    "aria-label": termLength,
    "data-term": numberOfTerm
  }, a11yAttributes), /*#__PURE__*/_react.default.createElement(_pillItem.default, {
    leftPanelContent: termContent,
    rightPanelContent: priceContent,
    icon: icon
  }));
}
DropDownPillMenuItem.propTypes = {
  id: _propTypes.default.string,
  savingsTag: _propTypes.default.string,
  termLength: _propTypes.default.string,
  termPrice: _propTypes.default.string,
  termTotalPrice: _propTypes.default.string,
  numberOfTerm: _propTypes.default.number,
  icon: _propTypes.default.node,
  a11yAttributes: _propTypes.default.object,
  isDomain: _propTypes.default.bool
};